import cciAxios from '@di-shared/api/cci/httpClient';
import {MeResponse, MyCarResponse, TokenExchangeParams, TokenExchangeResponse} from '@di-shared/api/cci/types';

export async function postAuthTokenExchange({serviceType, token}: TokenExchangeParams): Promise<TokenExchangeResponse> {
  const {data} = await cciAxios.post(
    `/auth/v1/token-exchange`,
    {},
    {
      params: {serviceType},
      headers: {
        'exchangeable-token': token,
        'client-version': '0.0.0',
      },
      cache: {ttl: 86400, interpretHeader: false},
    }
  );
  return data;
}

export async function getMe(): Promise<MeResponse> {
  const {data} = await cciAxios.get(`/user/v1/me`, {
    cache: {
      interpretHeader: false,
      ttl: 86400,
    },
  });
  return data;
}

export async function getMyCarDetail(vin: string): Promise<MyCarResponse> {
  const {data} = await cciAxios.get(`/vehicle/v1/detail?vin=${vin}`);
  return data;
}

export async function getMyCars(): Promise<{contents: Array<MyCarResponse>}> {
  const {data} = await cciAxios.get(`/vehicle/v1/available-vehicles`);
  return data;
}
